import { Category, Product } from '@v2/shared/lib/types';
import useUrlGenerator from '@v2/shared/lib/useUrlGenerator';
import NamedIcon from '@v2/shared/components/NamedIcon';

export type BooksLayoutData = {
  category: Category;
  categories: Category[];
  featuredCategories: Category[];
  bestSellers: Product[];
};

type Props = {
  category: Category;
  onClick?: () => void;
};

export default function CategoryCard({ category, onClick }: Props) {
  const { buildUrl } = useUrlGenerator();

  return (
    <a href={buildUrl(category.href)} onClick={onClick} className="block">
      <div className="w-full flex flex-col cursor-pointer">
        <div className="bg-slate-100 w-full rounded-md flex items-center justify-center text-2xl h-12 mb-1">
          <NamedIcon name={category.icon} className="text-slate-800" />
        </div>
        <div className="text-[11px] leading-tight font-medium text-center">{category.name}</div>
      </div>
    </a>
  );
}
